import type { LogsShipEntry } from './logs.models';

const STORAGE_KEY = 'st-a-eye-logs-ships';

export function readSavedLogsShips(): Readonly<Record<string, LogsShipEntry>> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw) as Record<string, LogsShipEntry>;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

/** Merge voyage groups by `voyageNo`; later entry wins per voyage. */
export function mergeLogsShipEntries(existing: LogsShipEntry, incoming: LogsShipEntry): LogsShipEntry {
  const byVoyage = new Map(existing.voyages.map((v) => [v.voyageNo, v] as const));
  for (const v of incoming.voyages) {
    byVoyage.set(v.voyageNo, v);
  }
  return {
    ...existing,
    ...incoming,
    voyages: [...byVoyage.values()],
  };
}

export function saveLogsShipEntry(entry: LogsShipEntry): void {
  const all = { ...readSavedLogsShips() };
  const prev = all[entry.id];
  all[entry.id] = prev ? mergeLogsShipEntries(prev, entry) : entry;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function mergeLogsShipCatalogue(
  mock: readonly LogsShipEntry[],
  saved: Readonly<Record<string, LogsShipEntry>>,
): readonly LogsShipEntry[] {
  const byId = new Map(mock.map((s) => [s.id, s]));
  for (const entry of Object.values(saved)) {
    const prev = byId.get(entry.id);
    byId.set(entry.id, prev ? mergeLogsShipEntries(prev, entry) : entry);
  }
  return [...byId.values()];
}
